import sanitizeHtml from 'sanitize-html'

export default (html = '') => sanitizeHtml(html, {
    allowedTags: ['br', 'span'],
    allowedAttributes: {
        span: ['style'],
    },
})

// a start-screen layout is authored by the workspace admin rather than by an end user, so it may
// carry real markup and its own <style> - the tenant can already restyle the widget through css
// variables. Scripts, on* handlers and javascript: urls are still dropped
export const sanitizeLayout = (html = '') => sanitizeHtml(html, {
    allowedTags: [
        'a', 'b', 'br', 'button', 'div', 'em', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'header', 'hr', 'i', 'img', 'li', 'ol', 'p', 'section', 'small', 'span', 'strong',
        'style', 'ul',
    ],
    allowedAttributes: {
        '*': ['class', 'id', 'style', 'lang', 'dir', 'data-tl-start'],
        a: ['href', 'target', 'rel'],
        button: ['type', 'disabled'],
        img: ['src', 'alt', 'width', 'height', 'loading'],
    },
    allowedSchemes: ['http', 'https', 'data'],
    allowVulnerableTags: true,
})
